module.exports = __webpack_public_path__ + "media/images/icon-er-f717b26fc48301ae2ccc2cd9274a2c2b.png";